import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

@Component({
    selector: "loadingindicator",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./loadingindicator.component.html",
})
export class LoadingIndicatorComponent {
    isLoading$: Observable<boolean>;

    constructor(store: Store<IAppStore>) {
        this.isLoading$ = store.select(e => {
            return (e.loading.loading && !e.loading.surpressLoading);
        });
    }
}
